import { render, staticRenderFns } from "./baSkillsModel.vue?vue&type=template&id=ba092946&scoped=true&lang=pug&"
import script from "./baSkillsModel.vue?vue&type=script&lang=js&"
export * from "./baSkillsModel.vue?vue&type=script&lang=js&"
import style0 from "./baSkillsModel.vue?vue&type=style&index=0&id=ba092946&lang=scss&scoped=true&"
import style1 from "./baSkillsModel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba092946",
  null
  
)

export default component.exports